/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkshopListItem } from './WorkshopListItem';
import {
    WorkshopListItemFromJSON,
    WorkshopListItemFromJSONTyped,
    WorkshopListItemToJSON,
    WorkshopListItemToJSONTyped,
} from './WorkshopListItem';

/**
 * One page of the workshops list.
 * @export
 * @interface PaginatedWorkshopsResponse
 */
export interface PaginatedWorkshopsResponse {
    /**
     * The workshops of the page
     * @type {Array<WorkshopListItem>}
     * @memberof PaginatedWorkshopsResponse
     */
    items: Array<WorkshopListItem>;
    /**
     * Total number of matching workshops
     * @type {number}
     * @memberof PaginatedWorkshopsResponse
     */
    total: number;
    /**
     * Number of records skipped
     * @type {number}
     * @memberof PaginatedWorkshopsResponse
     */
    skip: number;
    /**
     * Maximum number of records returned
     * @type {number}
     * @memberof PaginatedWorkshopsResponse
     */
    limit: number;
}

/**
 * Check if a given object implements the PaginatedWorkshopsResponse interface.
 */
export function instanceOfPaginatedWorkshopsResponse(value: object): value is PaginatedWorkshopsResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('skip' in value) || value['skip'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function PaginatedWorkshopsResponseFromJSON(json: any): PaginatedWorkshopsResponse {
    return PaginatedWorkshopsResponseFromJSONTyped(json, false);
}

export function PaginatedWorkshopsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedWorkshopsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(WorkshopListItemFromJSON)),
        'total': json['total'],
        'skip': json['skip'],
        'limit': json['limit'],
    };
}

export function PaginatedWorkshopsResponseToJSON(json: any): PaginatedWorkshopsResponse {
    return PaginatedWorkshopsResponseToJSONTyped(json, false);
}

export function PaginatedWorkshopsResponseToJSONTyped(value?: PaginatedWorkshopsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(WorkshopListItemToJSON)),
        'total': value['total'],
        'skip': value['skip'],
        'limit': value['limit'],
    };
}

